"use strict";
export { TabsContent as Content, TabsContentGroup as ContentGroup, TabsContext as Context, TabsIndicator as Indicator, TabsList as List, TabsPropsProvider as PropsProvider, TabsRoot as Root, TabsRootProvider as RootProvider, TabsTrigger as Trigger } from './tabs.js';
